import React, {useRef} from 'react';
import {ExcellenceMobileComponent} from './ExcellenceMobile.style';
import wheel from '../../../../public/image/WhyUs/Operational/mobile/wheel.webp';
import circles from '../../../../public/image/WhyUs/Operational/mobile/circles.webp';
import analysis from '../../../../public/image/WhyUs/Operational/mobile/analysis.webp';
import visibility from '../../../../public/image/WhyUs/Operational/mobile/visibility.webp';
import plans from '../../../../public/image/WhyUs/Operational/mobile/plans.webp';
import autonomy from '../../../../public/image/WhyUs/Operational/mobile/autonomy.webp';

const ExcellenceMobile = ({active}) => {
  const wrap = useRef();

  return (
    <ExcellenceMobileComponent
      secHeight={active ? wrap.current?.clientHeight : 0}>
      <div className='excellence' ref={wrap}>
        <div className='excellencemob__header'>
          <div className='excellencemob__header--container'>
            <p className='excellencemob__header--container-text'>
              Operational <br /> Excellence
            </p>
            <img
              src={wheel.src}
              alt=''
              className='excellencemob__header--container-img'
            />
            <img
              src={circles.src}
              alt=''
              className='excellencemob__header--container-img excellencemob__header--container-img-2'
            />
          </div>
        </div>
        <div className='excellencemob__section excellencemob__section-1'>
          <div className='excellencemob__section--header'>
            <img
              src={analysis.src}
              alt=''
              className='excellencemob__section--header-img'
            />
            <p className='excellencemob__section--header-text'>
              Function-Based <br /> Performance Analyses
            </p>
          </div>
          <p className='excellencemob__Section--content'>
            The{' '}
            <span className='excellencemob__Section--content--blue'>
              {'"LMS"'}
            </span>{' '}
            model guarantees an optimized value of each employee’s contribution
            through the conduction of{' '}
            <span>multi-tier, function-based performance analyses</span> to
            achieve extensive operational excellence.
          </p>
        </div>
        <div className='excellencemob__section'>
          <div className='excellencemob__section--header'>
            <img
              src={visibility.src}
              alt=''
              className='excellencemob__section--header-img'
            />
            <p className='excellencemob__section--header-text'>
              Multi-Layered Visibility
            </p>
          </div>
          <p className='excellencemob__Section--content'>
            Our periodic reports of performance parameters will help you gain{' '}
            <span>multi-layered visibility</span> by comparing actual
            performance with planned capacities for{' '}
            <span>insightful decision making.</span>
          </p>
        </div>
        <div className='excellencemob__section'>
          <div className='excellencemob__section--header'>
            <img
              src={plans.src}
              alt=''
              className='excellencemob__section--header-img'
            />
            <p className='excellencemob__section--header-text excellencemob__section--header-text2'>
              Objective-Based <br /> Readiness Plans
            </p>
          </div>
          <p className='excellencemob__Section--content'>
            The onboarding methodology we endorse ensures the readiness of new
            recruits with an <span>%85 target achievement rate</span> within the
            first <span>FOUR</span> weeks through the implementation of
            objective-based readiness plans for each function.
          </p>
        </div>
        <div className='excellencemob__section'>
          <div className='excellencemob__section--header'>
            <img
              src={autonomy.src}
              alt=''
              className='excellencemob__section--header-img'
            />
            <p className='excellencemob__section--header-text'>
              Operational Autonomy
            </p>
          </div>
          <p className='excellencemob__Section--content'>
            The{' '}
            <span className='excellencemob__Section--content-blue'>
              {'"LMS"'}
            </span>{' '}
            model is governed by a multi-functional, dedicated arm that ensures{' '}
            <span>operational autonomy and output/product optimization.</span>
          </p>
        </div>
      </div>
    </ExcellenceMobileComponent>
  );
};

export default ExcellenceMobile;
